import React from 'react';
import { useDesign } from '../contexts/DesignContext';

const About = () => {
  const { designConfig } = useDesign();

  return (
    <div 
      className="min-h-screen"
      style={{ backgroundColor: designConfig.background_color || '#FFF8F5' }}
    >
      {/* Hero Section */}
      <section 
        className="relative text-white py-24 md:py-32 overflow-hidden"
        style={{ 
          background: `linear-gradient(135deg, ${designConfig.primary_color || '#D4AF37'} 0%, ${designConfig.secondary_color || '#C9A9DD'} 50%, ${designConfig.accent_color || '#F4A5C7'} 100%)`
        }}
      >
        <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
        
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="flex items-center justify-center mb-6">
            <div className="h-px w-20" style={{ backgroundColor: 'rgba(255,255,255,0.3)' }}></div>
            <div className="mx-4 w-2 h-2 rounded-full bg-white"></div>
            <div className="h-px w-20" style={{ backgroundColor: 'rgba(255,255,255,0.3)' }}></div>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-light mb-6 tracking-wide" style={{ 
            fontFamily: 'serif',
            textShadow: '0 4px 20px rgba(0,0,0,0.2)'
          }}>
            About Us
          </h1>
          
          <div className="flex items-center justify-center mt-8">
            <div className="h-px w-20" style={{ backgroundColor: 'rgba(255,255,255,0.3)' }}></div>
            <div className="mx-4 w-2 h-2 rounded-full bg-white"></div>
            <div className="h-px w-20" style={{ backgroundColor: 'rgba(255,255,255,0.3)' }}></div>
          </div>
        </div>
      </section>

      {/* About Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-3xl shadow-lg p-12">
            <div 
              className="text-lg leading-relaxed space-y-6"
              style={{ color: designConfig.text_color }}
            >
              <p className="text-xl font-light" style={{ fontFamily: 'serif' }}>
                {designConfig.about_text || 'Welcome to our premium e-commerce store. We offer the best products with exceptional quality and service.'}
              </p>
              
              <p>
                At {designConfig.site_name || 'Viv Fashion Boutique'}, we are passionate about bringing you the finest collection of elegant fashion, designer bags, and luxury items. Our carefully curated selection reflects our commitment to quality, style, and customer satisfaction.
              </p>
              
              <p>
                We believe that every piece tells a story, and we're here to help you find the perfect items that reflect your unique style and personality. Whether you're looking for timeless classics or contemporary designs, we have something special for everyone.
              </p>
              
              <p>
                Thank you for choosing us as your trusted shopping destination. We look forward to serving you with excellence and helping you discover products that bring joy and elegance to your life.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;



